import add from 'date-fns/add';

export const periods = [
  {
    label: 'Last 12 Month',
    value: {
      from: add(new Date(), { months: -12 }),
      to: new Date(),
    },
  },
  {
    label: 'Last 6 Month',
    value: {
      from: add(new Date(), { months: -6 }),
      to: new Date(),
    },
  },
  {
    label: 'Last 30 Days',
    value: {
      from: add(new Date(), { days: -30 }),
      to: new Date(),
    },
  },
  {
    label: 'Last 7 Days',
    value: {
      from: add(new Date(), { days: -7 }),
      to: new Date(),
    },
  },
];
